import { formatTimeForDisplay, generateFreeformSlots, mergeAvailabilityWithBooked } from "@shared/datetime/timeSlotUtils";

function buildSlots({
  mode,
  slots,
  bookedSlots,
  date,
  now,
  startTime,
  endTime,
  intervalMinutes,
}) {
  if (mode === "freeform") {
    return generateFreeformSlots({ startTime, endTime, intervalMinutes }).map((time) => ({
      time,
      label: formatTimeForDisplay(time),
      status: "available",
    }));
  }
  return mergeAvailabilityWithBooked(slots || [], bookedSlots || [], { date, now });
}

export default function TimeSlotPicker({
  mode = "availability",
  slots = [],
  bookedSlots = [],
  date,
  now,
  value,
  onChange,
  multiple = false,
  startTime = "06:00",
  endTime = "23:00",
  intervalMinutes = 30,
  className = "",
}) {
  const normalizedSlots = buildSlots({ mode, slots, bookedSlots, date, now, startTime, endTime, intervalMinutes });
  const selectedValues = new Set(Array.isArray(value) ? value : value ? [value] : []);

  const toggleSlot = (slot) => {
    if (slot.status !== "available") return;
    if (!multiple) {
      onChange?.(slot.time);
      return;
    }
    const next = new Set(selectedValues);
    if (next.has(slot.time)) next.delete(slot.time);
    else next.add(slot.time);
    onChange?.(Array.from(next).sort());
  };

  if (!normalizedSlots.length) {
    return (
      <div className={`rounded-2xl border border-dashed border-[#DED7CC] bg-[#FDFBF7] p-5 text-center text-sm text-[#64756D] ${className}`}>
        No times available.
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 ${className}`}>
      {normalizedSlots.map((slot) => {
        const disabled = slot.status !== "available";
        const selected = selectedValues.has(slot.time);
        return (
          <button
            key={`${slot.time}-${slot.status}`}
            type="button"
            disabled={disabled}
            onClick={() => toggleSlot(slot)}
            className={[
              "min-h-11 rounded-xl border px-3 py-2 text-sm font-bold transition",
              selected ? "border-[#224032] bg-[#224032] text-white shadow-sm" : "border-[#DED7CC] bg-white text-[#224032]",
              disabled ? "cursor-not-allowed bg-[#F2EFE9] text-[#A0AAA4] line-through opacity-70" : "hover:border-[#224032] hover:bg-[#E9EEE7] active:scale-[0.98]",
            ].join(" ")}
          >
            {slot.label || slot.time}
          </button>
        );
      })}
    </div>
  );
}
